import { AxiosResponse } from 'axios';
import client from './clientLoggable';
import getAuthHeader from '@/util/getAuthHeader';
import { SensorData } from '@/store/modules/sensorMotion';

export default {
  async fetch(
    sensorData: SensorData[],
    accelerometerStatus: AccelerometerStatus,
    mediaData: MediaData[]
  ): Promise<AxiosResponse<Response>> {
    const request: Request = {
      sensorVersion: '1.0.0',
      sensorData,
      accelerometerStatus,
      mediaVersion: '1.0.0',
      mediaData
    };

    const response: AxiosResponse<Response> = await client.post<Response>('ux_logs', request, {
      headers: getAuthHeader()
    });

    return response;
  }
};

export enum AccelerometerStatus {
  GRANTED = 1,
  DENIED = 2,
  UNAVAILABLE = 3
}

export type MediaData = [string, string, string, string];

export interface Request {
  sensorVersion: '1.0.0';
  sensorData: SensorData[];
  accelerometerStatus: AccelerometerStatus;
  mediaVersion: '1.0.0';
  mediaData: MediaData[];
}

export type Response = void;
